import React, { Fragment } from "react";
import Logout from "../../components/Logout";
import { useArgusAuth } from "../../hooks/useArgusAuth";
import { Container } from "@mui/material";

const LogoutPage = () => {
	const {logout} = useArgusAuth();

	const performLogout = async () => {
		await logout({logoutParams: {returnTo: window.location.origin}});
	};

	return (
		<Container maxWidth="lg">
			<Logout logout={performLogout}/>
		</Container>
	);
};
export default LogoutPage;
